export type FieldName =
  | "fom"
  | "snr"
  | "ebi"
  | "halo"
  | "center_resolution"
  | "photocathode_sensitivity"
  | "tube_gain_level";

export const FIELD_NAME_OPTIONS: { value: FieldName; label: string }[] = [
  { value: "fom", label: "FOM (Figure of Merit)" },
  { value: "snr", label: "SNR (Signal-to-Noise Ratio)" },
  { value: "ebi", label: "EBI (Equivalent Background Illumination)" },
  { value: "halo", label: "Halo" },
  { value: "center_resolution", label: "Center Resolution (LP/mm)" },
  { value: "photocathode_sensitivity", label: "Photocathode Sensitivity" },
  { value: "tube_gain_level", label: "Tube Gain Level" },
];

export interface VariantOverride {
  id: number;
  source: string;
  external_variant_id: string;
  field_name: FieldName;
  match_value: string;
  override_value: string;
  tube_position: string | null;
  notes: string | null;
  is_active: boolean;
  applied_count: number;
  last_applied_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface OverrideListParams {
  source?: string;
  is_active?: boolean;
  limit?: number;
  offset?: number;
}

export interface CreateOverrideRequest {
  source: string;
  external_variant_id: string;
  field_name: FieldName;
  match_value: string;
  override_value: string;
  tube_position?: string | null;
  notes?: string | null;
}

export interface UpdateOverrideRequest {
  field_name?: FieldName;
  override_value?: string;
  tube_position?: string | null;
  notes?: string | null;
  is_active?: boolean;
}

export interface OverrideAppliedTube {
  variant_ids: number[];
  inventory_id: number;
  tube_id: number;
  tube_position: string | null;
  old_value: string;
  new_value: string;
}

export interface OverrideApplyResponse {
  override_id: number;
  dry_run: boolean;
  matched_variant_ids: number[];
  inventory_ids: number[];
  applied: OverrideAppliedTube[];
  no_match_reason: string | null;
  stale_review_variant_ids: number[];
  resolved_issue_ids: number[];
}
